<template>
  <div>
    <el-container>
      <el-header>
        <head_page :head_page_type="false" ref="head_page"></head_page>
      </el-header>

      <el-main>
        <div id="choose_city" style="backgroundcolor: white">
          <head_menu :has-back="true" @go-back-click="goBack"></head_menu>
        </div>
        <div>
          <el-button
            type="primary"
            plain
            size="small"
            round
            style="margin: 5px"
            @click="clickAddCompany()"
            >添加公司</el-button
          >
          <el-table
            :data="company_list"
            border
            style="width: 100%"
            v-loading="companyTableLoading"
          >
            <el-table-column
              prop="company_name"
              label="公司名称"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="company_name_cn"
              label="中文名称"
              width="200"
            ></el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="200"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="clickEditCompany(scope.row.id)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  @click="clickDeleteCompany(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>

      <!-- 添加公司对话框 -->
      <el-dialog
        title="添加公司"
        :visible.sync="addCompanyDialogVisible"
        width="30%"
      >
        <el-form :model="form_add_company" label-width="100px">
          <el-form-item label="公司名称">
            <el-input
              v-model="form_add_company.company_name"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="中文名称">
            <el-input
              v-model="form_add_company.company_name_cn"
              placeholder="请输入中文名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addCompanyDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="addCompanyConfirm">确认</el-button>
        </span>
      </el-dialog>

      <!-- 编辑公司对话框 -->
      <el-dialog
        title="编辑公司"
        :visible.sync="editCompanyDialogVisible"
        width="30%"
      >
        <el-form :model="form_edit_company" label-width="100px">
          <el-form-item label="公司名称">
            <el-input
              v-model="form_edit_company.company_name"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="中文名称">
            <el-input
              v-model="form_edit_company.company_name_cn"
              placeholder="请输入中文名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editCompanyDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="editCompanyConfirm">确认</el-button>
        </span>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import head_page from "./components/head_page.vue";
import head_menu from "./components/head_menu.vue";
import _global from "./components/global.vue";

export default {
  components: {
    head_page,
    head_menu,
  },
  data() {
    return {
      company_list: [],
      companyTableLoading: false,
      addCompanyDialogVisible: false,
      editCompanyDialogVisible: false,
      form_add_company: {
        company_name: "",
        company_name_cn: "",
      },
      form_edit_company: {
        id: null,
        company_name: "",
        company_name_cn: "",
      },
    };
  },
  mounted() {
    this.getCompanyList();
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    getCompanyList() {
      let api_url = _global.serverSrc + "/get_company_list/";
      var _self = this;
      let obj = { email: JSON.parse(sessionStorage.getItem("User")) };
      this.companyTableLoading = true;
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          _self.company_list = response.data.company_list;
          _self.companyTableLoading = false;
        })
        .catch((e) => {
          _self.companyTableLoading = false;
        });
    },
    clickAddCompany() {
      this.form_add_company = {
        company_name: "",
        company_name_cn: "",
      };
      this.addCompanyDialogVisible = true;
    },
    addCompanyConfirm() {
      let api_url = _global.serverSrc + "/add_company/";
      var _self = this;
      if (!this.form_add_company.company_name) {
        this.$notify.error({
          title: "Error",
          message: "请输入公司名称",
        });
        return;
      }
      let obj = {
        company_name: this.form_add_company.company_name,
        company_name_cn: this.form_add_company.company_name_cn,
        email: JSON.parse(sessionStorage.getItem("User")),
      };
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          if (response.data.is_ok === 1) {
            _self.addCompanyDialogVisible = false;
            _self.$message({ message: "添加公司成功" });
            _self.getCompanyList();
          } else {
            _self.$notify.error({
              title: "Error",
              message: _self.getErrorMessage(response.data.error),
            });
          }
        })
        .catch((e) => {});
    },
    clickEditCompany(companyId) {
      let api_url = _global.serverSrc + "/get_company_detail/";
      var _self = this;
      let obj = {
        company_id: companyId,
        email: JSON.parse(sessionStorage.getItem("User")),
      };
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          if (response.data.is_ok === 1) {
            _self.form_edit_company = {
              id: response.data.company.id,
              company_name: response.data.company.company_name,
              company_name_cn: response.data.company.company_name_cn,
            };
            _self.editCompanyDialogVisible = true;
          } else {
            _self.$notify.error({
              title: "Error",
              message: _self.getErrorMessage(response.data.error),
            });
          }
        })
        .catch((e) => {});
    },
    editCompanyConfirm() {
      let api_url = _global.serverSrc + "/update_company/";
      var _self = this;
      if (!this.form_edit_company.company_name) {
        this.$notify.error({
          title: "Error",
          message: "请输入公司名称",
        });
        return;
      }
      let obj = {
        company_id: this.form_edit_company.id,
        company_name: this.form_edit_company.company_name,
        company_name_cn: this.form_edit_company.company_name_cn,
        email: JSON.parse(sessionStorage.getItem("User")),
      };
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          if (response.data.is_ok === 1) {
            _self.editCompanyDialogVisible = false;
            _self.$message({ message: "更新公司成功" });
            _self.getCompanyList();
          } else {
            _self.$notify.error({
              title: "Error",
              message: _self.getErrorMessage(response.data.error),
            });
          }
        })
        .catch((e) => {});
    },
    clickDeleteCompany(company) {
      this.$confirm(`确认删除公司"${company.company_name}"？`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let api_url = _global.serverSrc + "/delete_company/";
          var _self = this;
          let obj = {
            company_id: company.id,
            email: JSON.parse(sessionStorage.getItem("User")),
          };
          this.$axios
            .post(api_url, obj)
            .then((response) => {
              if (response.data.is_ok === 1) {
                _self.$message({ message: "删除公司成功" });
                _self.getCompanyList();
              } else {
                _self.$notify.error({
                  title: "Error",
                  message: _self.getErrorMessage(response.data.error),
                });
              }
            })
            .catch((e) => {});
        })
        .catch(() => {});
    },
    getErrorMessage(errorCode) {
      const errorMessages = {
        company_name_required: "请输入公司名称",
        company_name_exists: "公司名称已存在",
        company_id_required: "公司ID不能为空",
        company_not_found: "公司不存在",
        company_has_associated_users: "该公司有关联的外部用户，无法删除",
      };
      return errorMessages[errorCode] || "操作失败";
    },
  },
};
</script>

<style scoped></style>
